"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerMultilingualVoiceActors = exports.ProducerEventVoiceLanguageLabels = void 0;
const enums_1 = require("../../enums");
exports.ProducerEventVoiceLanguageLabels = {
    [enums_1.ProducerEventVoiceLanguage.afZA]: "Afrikaans (South Africa)",
    [enums_1.ProducerEventVoiceLanguage.amET]: "Amharic (Ethiopia)",
    [enums_1.ProducerEventVoiceLanguage.arEG]: "Arabic (Egypt)",
    [enums_1.ProducerEventVoiceLanguage.arSA]: "Arabic (Saudi Arabia)",
    [enums_1.ProducerEventVoiceLanguage.azAZ]: "Azerbaijani (Azerbaijan)",
    [enums_1.ProducerEventVoiceLanguage.bgBG]: "Bulgarian (Bulgaria)",
    [enums_1.ProducerEventVoiceLanguage.bnBD]: "Bengali (Bangladesh)",
    [enums_1.ProducerEventVoiceLanguage.bnIN]: "Bengali (India)",
    [enums_1.ProducerEventVoiceLanguage.bsBA]: "Bosnian (Bosnia and Herzegovina)",
    [enums_1.ProducerEventVoiceLanguage.caES]: "Catalan (Spain)",
    [enums_1.ProducerEventVoiceLanguage.csCZ]: "Czech (Czech Republic)",
    [enums_1.ProducerEventVoiceLanguage.cyGB]: "Welsh (United Kingdom)",
    [enums_1.ProducerEventVoiceLanguage.daDK]: "Danish (Denmark)",
    [enums_1.ProducerEventVoiceLanguage.deAT]: "German (Austria)",
    [enums_1.ProducerEventVoiceLanguage.deCH]: "German (Switzerland)",
    [enums_1.ProducerEventVoiceLanguage.deDE]: "German (Germany)",
    [enums_1.ProducerEventVoiceLanguage.elGR]: "Greek (Greece)",
    [enums_1.ProducerEventVoiceLanguage.enAU]: "English (Australia)",
    [enums_1.ProducerEventVoiceLanguage.enCA]: "English (Canada)",
    [enums_1.ProducerEventVoiceLanguage.enGB]: "English (United Kingdom)",
    [enums_1.ProducerEventVoiceLanguage.enHK]: "English (Hong Kong)",
    [enums_1.ProducerEventVoiceLanguage.enIE]: "English (Ireland)",
    [enums_1.ProducerEventVoiceLanguage.enIN]: "English (India)",
    [enums_1.ProducerEventVoiceLanguage.enUS]: "English (United States)",
    [enums_1.ProducerEventVoiceLanguage.esEs]: "Spanish (Spain)",
    [enums_1.ProducerEventVoiceLanguage.esMX]: "Spanish (Mexico)",
    [enums_1.ProducerEventVoiceLanguage.esUS]: "Spanish (United States)",
    [enums_1.ProducerEventVoiceLanguage.etEE]: "Estonian (Estonia)",
    [enums_1.ProducerEventVoiceLanguage.euES]: "Basque (Spain)",
    [enums_1.ProducerEventVoiceLanguage.faIR]: "Persian (Iran)",
    [enums_1.ProducerEventVoiceLanguage.fiFI]: "Finnish (Finland)",
    [enums_1.ProducerEventVoiceLanguage.filPH]: "Filipino (Philippines)",
    [enums_1.ProducerEventVoiceLanguage.frBE]: "French (Belgium)",
    [enums_1.ProducerEventVoiceLanguage.frCA]: "French (Canada)",
    [enums_1.ProducerEventVoiceLanguage.frCH]: "French (Switzerland)",
    [enums_1.ProducerEventVoiceLanguage.frFR]: "French (France)",
    [enums_1.ProducerEventVoiceLanguage.gaIE]: "Irish (Ireland)",
    [enums_1.ProducerEventVoiceLanguage.glES]: "Galician (Spain)",
    [enums_1.ProducerEventVoiceLanguage.heIL]: "Hebrew (Israel)",
    [enums_1.ProducerEventVoiceLanguage.hiIN]: "Hindi (India)",
    [enums_1.ProducerEventVoiceLanguage.hrHR]: "Croatian (Croatia)",
    [enums_1.ProducerEventVoiceLanguage.huHU]: "Hungarian (Hungary)",
    [enums_1.ProducerEventVoiceLanguage.hyAM]: "Armenian (Armenia)",
    [enums_1.ProducerEventVoiceLanguage.idID]: "Indonesian (Indonesia)",
    [enums_1.ProducerEventVoiceLanguage.isIS]: "Icelandic (Iceland)",
    [enums_1.ProducerEventVoiceLanguage.itIT]: "Italian (Italy)",
    [enums_1.ProducerEventVoiceLanguage.jaJP]: "Japanese (Japan)",
    [enums_1.ProducerEventVoiceLanguage.jvID]: "Javanese (Indonesia)",
    [enums_1.ProducerEventVoiceLanguage.kaGE]: "Georgian (Georgia)",
    [enums_1.ProducerEventVoiceLanguage.kkKZ]: "Kazakh (Kazakhstan)",
    [enums_1.ProducerEventVoiceLanguage.kmKH]: "Khmer (Cambodia)",
    [enums_1.ProducerEventVoiceLanguage.knIN]: "Kannada (India)",
    [enums_1.ProducerEventVoiceLanguage.koKR]: "Korean (South Korea)",
    [enums_1.ProducerEventVoiceLanguage.loLA]: "Lao (Laos)",
    [enums_1.ProducerEventVoiceLanguage.ltLT]: "Lithuanian (Lithuania)",
    [enums_1.ProducerEventVoiceLanguage.lvLV]: "Latvian (Latvia)",
    [enums_1.ProducerEventVoiceLanguage.mkMK]: "Macedonian (North Macedonia)",
    [enums_1.ProducerEventVoiceLanguage.mlIN]: "Malayalam (India)",
    [enums_1.ProducerEventVoiceLanguage.mnMN]: "Mongolian (Mongolia)",
    [enums_1.ProducerEventVoiceLanguage.msMY]: "Malay (Malaysia)",
    [enums_1.ProducerEventVoiceLanguage.mtMT]: "Maltese (Malta)",
    [enums_1.ProducerEventVoiceLanguage.myMM]: "Myanmar (Myanmar)",
    [enums_1.ProducerEventVoiceLanguage.nbNO]: "Norwegian Bokmål (Norway)",
    [enums_1.ProducerEventVoiceLanguage.neNP]: "Nepali (Nepal)",
    [enums_1.ProducerEventVoiceLanguage.nlBE]: "Dutch (Belgium)",
    [enums_1.ProducerEventVoiceLanguage.nlNL]: "Dutch (Netherlands)",
    [enums_1.ProducerEventVoiceLanguage.plPL]: "Polish (Poland)",
    [enums_1.ProducerEventVoiceLanguage.psAF]: "Pashto (Afghanistan)",
    [enums_1.ProducerEventVoiceLanguage.ptBR]: "Portuguese (Brazil)",
    [enums_1.ProducerEventVoiceLanguage.ptPT]: "Portuguese (Portugal)",
    [enums_1.ProducerEventVoiceLanguage.roRO]: "Romanian (Romania)",
    [enums_1.ProducerEventVoiceLanguage.ruRU]: "Russian (Russia)",
    [enums_1.ProducerEventVoiceLanguage.siLK]: "Sinhala (Sri Lanka)",
    [enums_1.ProducerEventVoiceLanguage.skSK]: "Slovak (Slovakia)",
    [enums_1.ProducerEventVoiceLanguage.slSI]: "Slovenian (Slovenia)",
    [enums_1.ProducerEventVoiceLanguage.soSO]: "Somali (Somalia)",
    [enums_1.ProducerEventVoiceLanguage.sqAL]: "Albanian (Albania)",
    [enums_1.ProducerEventVoiceLanguage.srRS]: "Serbian (Serbia)",
    [enums_1.ProducerEventVoiceLanguage.suID]: "Sundanese (Indonesia)",
    [enums_1.ProducerEventVoiceLanguage.svSE]: "Swedish (Sweden)",
    [enums_1.ProducerEventVoiceLanguage.swKE]: "Swahili (Kenya)",
    [enums_1.ProducerEventVoiceLanguage.taIN]: "Tamil (India)",
    [enums_1.ProducerEventVoiceLanguage.teIN]: "Telugu (India)",
    [enums_1.ProducerEventVoiceLanguage.thTH]: "Thai (Thailand)",
    [enums_1.ProducerEventVoiceLanguage.trTR]: "Turkish (Turkey)",
    [enums_1.ProducerEventVoiceLanguage.ukUA]: "Ukrainian (Ukraine)",
    [enums_1.ProducerEventVoiceLanguage.urPK]: "Urdu (Pakistan)",
    [enums_1.ProducerEventVoiceLanguage.uzUZ]: "Uzbek (Uzbekistan)",
    [enums_1.ProducerEventVoiceLanguage.viVN]: "Vietnamese (Vietnam)",
    [enums_1.ProducerEventVoiceLanguage.zhCN]: "Chinese (Simplified, China)",
    [enums_1.ProducerEventVoiceLanguage.zhHK]: "Chinese (Hong Kong)",
    [enums_1.ProducerEventVoiceLanguage.zhTW]: "Chinese (Traditional, Taiwan)",
    [enums_1.ProducerEventVoiceLanguage.zuZA]: "Zulu (South Africa)",
};
const toLanguageList = (ids) => ids.map(locale => {
    const id = locale;
    return {
        id,
        label: exports.ProducerEventVoiceLanguageLabels[id],
    };
});
const ALL_MULTILINGUAL_LANGUAGE_IDS = [
    "af-ZA",
    "am-ET",
    "ar-EG",
    "ar-SA",
    "az-AZ",
    "bg-BG",
    "bn-BD",
    "bn-IN",
    "bs-BA",
    "ca-ES",
    "cs-CZ",
    "cy-GB",
    "da-DK",
    "de-AT",
    "de-CH",
    "de-DE",
    "el-GR",
    "en-AU",
    "en-CA",
    "en-GB",
    "en-IE",
    "en-IN",
    "en-US",
    "es-ES",
    "es-MX",
    "es-US",
    "et-EE",
    "eu-ES",
    "fa-IR",
    "fi-FI",
    "fil-PH",
    "fr-BE",
    "fr-CA",
    "fr-CH",
    "fr-FR",
    "ga-IE",
    "gl-ES",
    "he-IL",
    "hi-IN",
    "hr-HR",
    "hu-HU",
    "hy-AM",
    "id-ID",
    "is-IS",
    "it-IT",
    "ja-JP",
    "jv-ID",
    "ka-GE",
    "kk-KZ",
    "km-KH",
    "kn-IN",
    "ko-KR",
    "lo-LA",
    "lt-LT",
    "lv-LV",
    "mk-MK",
    "ml-IN",
    "mn-MN",
    "ms-MY",
    "mt-MT",
    "my-MM",
    "nb-NO",
    "ne-NP",
    "nl-BE",
    "nl-NL",
    "pl-PL",
    "ps-AF",
    "pt-BR",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "si-LK",
    "sk-SK",
    "sl-SI",
    "so-SO",
    "sq-AL",
    "sr-RS",
    "su-ID",
    "sv-SE",
    "sw-KE",
    "ta-IN",
    "te-IN",
    "th-TH",
    "tr-TR",
    "uk-UA",
    "ur-PK",
    "uz-UZ",
    "vi-VN",
    "zh-CN",
    "zh-HK",
    "zh-TW",
    "zu-ZA",
];
const JENNY_MULTILINGUAL_LANGUAGE_IDS = [
    "ar-EG",
    "ar-SA",
    "ca-ES",
    "cs-CZ",
    "da-DK",
    "de-AT",
    "de-CH",
    "de-DE",
    "en-AU",
    "en-CA",
    "en-GB",
    "en-HK",
    "en-IE",
    "en-IN",
    "en-US",
    "es-ES",
    "es-MX",
    "es-US",
    "fi-FI",
    "fr-BE",
    "fr-CA",
    "fr-CH",
    "fr-FR",
    "hi-IN",
    "hu-HU",
    "id-ID",
    "it-IT",
    "ja-JP",
    "ko-KR",
    "nb-NO",
    "nl-BE",
    "nl-NL",
    "pl-PL",
    "pt-BR",
    "pt-PT",
    "ru-RU",
    "sv-SE",
    "th-TH",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW",
];
const ALL_MULTILINGUAL_LANGUAGES = toLanguageList(ALL_MULTILINGUAL_LANGUAGE_IDS);
const JENNY_MULTILINGUAL_LANGUAGES = toLanguageList(JENNY_MULTILINGUAL_LANGUAGE_IDS);
exports.ProducerMultilingualVoiceActors = [
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.AlloyTurboMultilingual,
        name: "Alloy Turbo Multilingual",
        gender: enums_1.ProducerGender.Male,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.DerekMultilingual,
        name: "Derek Multilingual",
        gender: enums_1.ProducerGender.Male,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.LewisMultilingual,
        name: "Lewis Multilingual",
        gender: enums_1.ProducerGender.Male,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.ShimmerTurboMultilingual,
        name: "Shimmer Turbo Multilingual",
        gender: enums_1.ProducerGender.Female,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.JennyMultilingual,
        name: "Jenny Multilingual",
        gender: enums_1.ProducerGender.Female,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: JENNY_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.LolaMultilingual,
        name: "Lola Multilingual",
        gender: enums_1.ProducerGender.Female,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.AvaMultilingual,
        name: "Ava Multilingual",
        gender: enums_1.ProducerGender.Female,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.AmandaMultilingual,
        name: "Amanda Multilingual",
        gender: enums_1.ProducerGender.Female,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.EchoTurboMultilingual,
        name: "Echo Turbo Multilingual",
        gender: enums_1.ProducerGender.Male,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.NancyMultilingual,
        name: "Nancy Multilingual",
        gender: enums_1.ProducerGender.Female,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
    {
        id: enums_1.ProducerEventMultilingualVoiceActor.NovaTurboMultilingual,
        name: "Nova Turbo Multilingual",
        gender: enums_1.ProducerGender.Female,
        defaultLanguage: enums_1.ProducerEventVoiceLanguage.enUS,
        languages: ALL_MULTILINGUAL_LANGUAGES,
    },
];
//# sourceMappingURL=multilingualVoiceActors.js.map